export const colorPallateGenerator = (string) => {
  let hex_strings = '01203456789';
  if (string) {
    hex_strings += string;
  } else {
    hex_strings += 'ABCDEF';
  }
  let multiplier = hex_strings.length;
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += hex_strings[Math.floor(Math.random() * multiplier)];
  }

  return color;
};
